<template>
    <f7-page class="page-my-profile has-footer">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>THÔNG TIN CÁ NHÂN</f7-nav-title>
        </f7-navbar>
        <f7-list inset>
            <f7-list-input
                type="text"
                outline
                floating-label
                label="Tên hiển thị"
                placeholder="Tên hiển thị"
                :value="form_update.fullname"
                @input="form_update.fullname = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
                v-if="user_info.telegram_fullname || user_info.telegram_username"
                type="text"
                outline
                floating-label
                label="Telegram"
                placeholder="Telegram"
                :disabled="true"
                :value="user_info.telegram_fullname ? user_info.telegram_fullname : user_info.telegram_username"
            >
            </f7-list-input>
            <f7-list-input
                type="text"
                outline
                floating-label
                label="Người giới thiệu"
                placeholder="Người giới thiệu"
                :disabled="referal_lock"
                :value="form_update.referal"
                @input="form_update.referal = $event.target.value"
            >
            </f7-list-input>
        </f7-list>
        <f7-block inset>
            <f7-button fill color="primary" @click.prevent="submitFormChange">
                LƯU THÔNG TIN
            </f7-button>
        </f7-block>
    </f7-page>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            referal_lock: false,
            form_update: {
                fullname: '',
                referal: '',
            }
        }
    },
    computed: {
        ...mapState(['user_info'])
    },
    methods: {
        submitFormChange() {
            if (this.form_update.fullname === '') {
                this.$f7.dialog.alert('Vui lòng nhập Tên hiển thị', 'LỖI');
                return false;
            }

            let form_update = this._.cloneDeep(this.form_update);

            if (this.referal_lock === true) {
                form_update.referal = '';
            }

            this.$f7.preloader.show();

            this.$store.dispatch('updateUserInfo', form_update)
                .then(() => {
                    return this.$store.dispatch('getMe');
                })
                .then(() => {
                    this.$f7.preloader.hide();
                    this.$f7.dialog.alert('Đã cập nhật thông tin', 'THÔNG BÁO');
                })
                .catch((error) => {
                    this.$f7.preloader.hide();
                    this.$f7.dialog.alert(error, 'LỖI');
                });
        }
    },
    mounted() {
        this.form_update.fullname = this.user_info.fullname;
        this.form_update.referal = this.user_info.referal;
        this.referal_lock = !this._.isEmpty(this.user_info.referal);
    }
};
</script>
